<div class="login-wrapper">
    <!-- Background shapes -->
    <div class="shape shape-1"></div>
    <div class="shape shape-2"></div>
    <div class="shape shape-3"></div>

    <div class="glass-card">
        <div class="logo">
            <img src="./assets/media/msis/main-logo.png" alt="MSIS INC" />
        </div>
        <h1>Welcome Back</h1>
        <p class="subtitle">Sign in to Carmen</p>

        <div *ngIf="forgotFlow" class="success-msg">Your password has been changed successfully</div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="field">
                <label for="email">Email</label>
                <input type="text" formControlName="email" [(ngModel)]="email"
                    placeholder="Enter your email"
                    [class.field-error]="submitted && f.email.errors" />
                <div *ngIf="submitted && f.email.errors" class="error-text">
                    <span *ngIf="f.email.errors.required">Email is required</span>
                </div>
            </div>
            <div class="field">
                <label for="password">Password</label>
                <input type="password" formControlName="password" [(ngModel)]="password"
                    placeholder="Enter your password"
                    [class.field-error]="submitted && f.password.errors" />
                <div *ngIf="submitted && f.password.errors" class="error-text">
                    <span *ngIf="f.password.errors.required">Password is required</span>
                </div>
            </div>
            <div class="meta">
                <div class="check-row">
                    <input type="checkbox" id="remember" />
                    <label for="remember">Remember me</label>
                </div>
                <a routerLink="/forgot-password" class="forgot" tabindex="-1">Forgot Password?</a>
            </div>
            <div *ngIf="error" class="error-banner">{{ error }}</div>
            <button type="submit" [disabled]="loading" class="btn-login">
                <span *ngIf="loading" class="spinner"></span>
                Sign In
            </button>
        </form>
        <p class="version">Carmen v3.0.0</p>
    </div>
</div>
